<template>
  <div class="auth-wrapper">
    <section class="section">
      <h1 class="is-size-4 has-text-grey">
        {{ $t('Секунду... Авторизируемся') }}
        <span class="loader auth-wrapper-loader"></span>
      </h1>
    </section>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  async mounted () {
    const {
      access_token: accessToken
    } = this.$route.query
    if (accessToken) {
      try {
        await this.logout()
        await this.authenticate({
          accessToken
        })
      } catch (e) {
        // console.log(e)
      }
    }
    window.location.replace(`/`)
  },
  methods: {
    ...mapActions('authentication', ['authenticate', 'logout'])
  }
}
</script>
<style>

</style>
